import { Typography } from "@mui/material";
import Box from "@mui/material/Box";
import React from "react";

interface PageHeaderProps {
    title: string;
    subtitle?: string;
}

const PageHeader: React.FC<PageHeaderProps> = ({ title, subtitle }) => {
    return (
      <Box sx={{ padding: "24px 24px 12px 24px"}}>
        <Typography variant="h5">{title}</Typography>
        {subtitle && <Typography variant="subtitle1">{subtitle}</Typography>}
      </Box>
    );
};

export default PageHeader;
